"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        display: 'flex',
        color: 'currentColor'
    },
    logoMark: {
        flexBasis: '23.4741784%',
        height: '100%'
    },
    logoText: {
        flexBasis: '76.5258216%',
        height: '100%'
    }
};
//# sourceMappingURL=logo.style.js.map